import { MOSCOW_AREA_REGION_ID, MOSCOW_REGION_ID, MOSCOW_WITH_AREA_REGION_ID } from '../geo';
import { TDropdownType } from '../../components/DropdownMenu/interfaces';
import { IDropdownMenuRandomLink } from '../../types/dropdownMenuLink';
import { IFskBanner } from '../../types/fsk';

export const FSK_SP_NAME = 'fsk';
export const FSK_SP_URL = 'https://www.cian.ru/zastroishchik-gk-fsk-5747/';
export const FSK_SP_BANNER_SECTIONS: TDropdownType[] = ['newbuildings'];
export const FSK_SP_REGIONS = [MOSCOW_REGION_ID, MOSCOW_WITH_AREA_REGION_ID, MOSCOW_AREA_REGION_ID];
export const FSK_SP_LINK_SECTIONS: string[] = ['new-buildings', 'sale'];
export const FSK_SP_LINK: IDropdownMenuRandomLink = {
  regionIds: FSK_SP_REGIONS,
  chance: 50,
  link: {
    text: 'Новостройки от ГК ФСК',
    icon: FSK_SP_NAME,
    url: FSK_SP_URL,
    isBold: true,
  },
};
export const FSK_SP_BANNER: IFskBanner = {
  link: 'https://www.cian.ru/zastroishchik-gk-fsk-5747/',
  image: '',
  width: 310,
  height: 184,
};
